<style lang="less" scoped>
  @import "../../../assets/css/table-list.css";
  @import "../report.less";
</style>
<style lang="less">
  .report{
    .ivu-table-border td:nth-child(5) .ivu-table-cell,
    .ivu-table-border td:nth-child(6) .ivu-table-cell{
      padding:0;
      p{
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        padding:10px;
      }
    }
  }
</style>
<template>
  <div class="report">
    <h3 class="title">合同执行情况明细表</h3>
    <div class="margin-bottom-10">
      <DatePicker :value="currYear" type="year" :clearable="false" placeholder="选择年限" style="width: 200px" @on-change="change_date"></DatePicker>
    </div>
    <section>
      <Table :columns="d_columns" :data="d_data_self" border disabled-hover></Table><br>
      <Table :columns="d_columns2" :data="d_data_instead" border disabled-hover :show-header=false></Table>
    </section>
  </div>
</template>
<script>
  import apiReport from '@/api/report.js';
  export default {
    name:'shopReport',
    data() {
      return {
        d_columns:[
          {
            title: '费用项目',
            align: 'center',
            children: [
              {
                title: '大项',
                key: 'TypeBig',
                align: 'center'
              },
              {
                title: '小项',
                key: 'XiaoXiang',
                align: 'center'
              }
            ]
          },
          {
            title: '合同应收款项',
            align: 'center',
            children: [
              {
                title: '未收前期合同金额',
                key: 'Weishouqianqi',
                align: 'center',
                render: (h, params) => {
                  return h('span',params.row.Weishouqianqi+'元')
                }
              },
              {
                title: '本期应收合同金额',
                key: 'Benqiyingshou',
                align: 'center',
                render: (h, params) => {
                  return h('span',params.row.Benqiyingshou+'元')
                }
              },
              {
                title: '应收合同金额小计',
                key: 'Yingshouxiaoji',
                align: 'center',
                render: (h, params) => {
                  return h('span',params.row.Yingshouxiaoji+'元')
                }
              },
              {
                title: '实收前期合同金额',
                key: 'ShishouQianqi',
                align: 'center',
                render: (h, params) => {
                  return h('span',params.row.ShishouQianqi+'元')
                }
              },
              {
                title: '本期实收合同金额',
                key: 'Benqishishou',
                align: 'center',
                render: (h, params) => {
                  return h('span',params.row.Benqishishou+'元')
                }
              },
              {
                title: '实收合同金额小计',
                key: 'Shishouxiaoji',
                align: 'center',
                render: (h, params) => {
                  return h('span',params.row.Shishouxiaoji+'元')
                }
              },
              {
                title: '合同金额余额',
                key: 'Hetongyue',
                align: 'center',
                render: (h, params) => {
                  return h('span',params.row.Hetongyue+'元')
                }
              }
            ]
          }
        ],
        d_columns2:[
          {
            title: '费用项目',
            align: 'center',
            children: [
              {
                title: '大项',
                key: 'TypeBig',
                align: 'center'
              },
              {
                title: '小项',
                key: 'XiaoXiang',
                align: 'center'
              }
            ]
          },
          {
            title: '合同应收款项',
            align: 'center',
            children: [
              {
                title: '未收前期合同金额',
                key: 'Weishouqianqi',
                align: 'center',
                render: (h, params) => {
                  return h('span',params.row.Weishouqianqi+'元')
                }
              },
              {
                title: '本期应收合同金额',
                key: 'Benqiyingshou',
                align: 'center',
                render: (h, params) => {
                  return h('span',params.row.Benqiyingshou+'元')
                }
              },
              {
                title: '应收合同金额小计',
                key: 'Yingshouxiaoji',
                align: 'center',
                render: (h, params) => {
                  return h('span',params.row.Yingshouxiaoji+'元')
                }
              },
              {
                title: '实收前期合同金额',
                key: 'ShishouQianqi',
                align: 'center',
                render: (h, params) => {
                  return h('span',params.row.ShishouQianqi+'元')
                }
              },
              {
                title: '本期实收合同金额',
                key: 'Benqishishou',
                align: 'center',
                render: (h, params) => {
                  return h('span',params.row.Benqishishou+'元')
                }
              },
              {
                title: '实收合同金额小计',
                key: 'Shishouxiaoji',
                align: 'center',
                render: (h, params) => {
                  return h('span',params.row.Shishouxiaoji+'元')
                }
              },
              {
                title: '合同金额余额',
                key: 'Hetongyue',
                align: 'center',
                render: (h, params) => {
                  return h('span',params.row.Hetongyue+'元')
                }
              }
            ]
          }
        ],
        currYear: this.to_date(new Date()).split('-')[0],
        d_data_self: [],
        d_data_instead: [],
        d_all_type_obj:{
        self:[],
          agent:[]
      }
      };
    },
    methods: {
      to_date(date){
        let moment = require('moment');
        return moment(date).format('YYYY-MM-DD');
      },
      change_date(date){
        this.currYear = date;
        this.pull_data();
      },
      pull_data() {
        let _this = this;
        apiReport.GetReport2(this.currYear).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            let requestResult = _data.data.Data;
            this.d_data_self = [];
              this.d_data_instead = [];
            if (requestResult.length<=0) return;
            let rowListSelf = [],rowListInstead = [];
            let arrObj = {
              TypeBig:'',
              XiaoXiang:'',
              Weishouqianqi:0,
              Benqiyingshou:0,
              Yingshouxiaoji:0,
              ShishouQianqi:0,
              Benqishishou:0,
              Shishouxiaoji:0,
              Hetongyue:0
            };
            let typeSelfArr = this.d_all_type_obj.self;
            let typeInsteadArr = this.d_all_type_obj.agent;
            let newArr = [];
            for(let item of typeSelfArr.concat(typeInsteadArr)){
              let o1 = { XiaoXiang: item }
              let o2 = JSON.parse(JSON.stringify(arrObj));
              let o3 = Object.assign(o2, o1);
              newArr.push(o3);
            }
            for(let item of newArr){
              let param = item;
              for(let i=0;i<requestResult.length;i++){
                if(requestResult[i].XiaoXiang === item.XiaoXiang){
                  param = Object.assign(item, requestResult[i]);
                }
              }
              if(typeSelfArr.indexOf(item.XiaoXiang)>-1){
                item.TypeBig = '自收类费用';
                rowListSelf.push(param);
              }else{
                item.TypeBig = '代收类费用';
                rowListInstead.push(param);
              }
            }
//用于合计
            let columnsPop = [
              { property:'TypeBig' },
              { property:'XiaoXiang' },
              { property:'Weishouqianqi' },
              { property:'Benqiyingshou' },
              { property:'Yingshouxiaoji' },
              { property:'ShishouQianqi' },
              { property:'Benqishishou' },
              { property:'Shishouxiaoji' },
              { property:'Hetongyue' }
            ]; //用于合计取数据
            this.d_data_self = rowListSelf;
            let param = {
              columns: columnsPop,
              data:rowListSelf
            };
            let totalNumSelf = this.getSummaries(param,'自收类合计');
            rowListSelf.push(totalNumSelf);
            this.d_data_instead = rowListInstead;
            setTimeout(function () {
              let param2 = {
                columns: columnsPop,
                data:rowListInstead
              };
              let totalNumInstead = _this.getSummaries(param2,'代收类合计');
              rowListInstead.push(totalNumInstead);
            },500);
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      getSummaries(param,name) {
        const { columns, data } = param;
        const sums = {};
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[column.property] = name;
            return;
          }
          if (index === 1) {
            sums[column.property] = '类型';
            return;
          }
          const values = data.map(item => Number(item[column.property])); //分组获取第一列的所有数据
          if (!values.every(value => isNaN(value))) {
            sums[column.property] = values.reduce((prev, curr) => { //循环加起来赋值给当前属性
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
//            sums[column.property] += ' 元';
          } else {
            sums[column.property] = 'N/A';
          }
        });

        return sums;
      }
    },
    created() {
      let billType = this.$store.state.app.billType;
      let selfType = billType.selfRent.concat(billType.self2);
      let insteadType = billType.instead;
      this.d_all_type_obj.self = selfType.map(item=>item.value);
      this.d_all_type_obj.agent = insteadType.map(item=>item.value);

     this.pull_data()
    },

    mounted(){

    }
  }
</script>
